/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useCallback, useMemo } from 'react'

function useArrayFilter (value: string[], onChange: (name: string, value: string[]) => void): [string[], (event: React.ChangeEvent) => void] {
  const array = useMemo(() => value || [], [value])

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event
    const { checked, name } = target

    if (checked) {
      onChange(name, [...array, target.value])
    } else {
      onChange(name, array.filter((el) => el !== target.value))
    }
  }, [onChange, array])

  return [array, handleChange]
}

export default useArrayFilter
